<button type="button" class="btn btn-default btn-sm p-0 browse-button" [ngClass]="{'file-browser-button': iconOnly}"
        title="Browse" (click)="openFileBrowser()">
  <i class="fa fa-folder"></i> {{!iconOnly ? 'Browse' : '' }}
</button>
